import Product from '../components/product/Product';
import { openModal } from './modals';
import reinitSwymActionButtons from './reinitSwymActionButtons';
import showQuickshop from './showQuickshop';

const selectors = {
  modalContent: 'quickshop-content',
  modalProduct: '[data-product]',
};

/**
 * Opens the quickshop modal with a product.
 * Fetches the product section via Section Rendering API, injects into modal, and initializes Product.
 *
 * @param {string} productUrl - Product URL path (e.g. /products/handle)
 * @returns {Promise<boolean>} - Resolves to true if opened successfully
 */
export default function openQuickshop(productUrl) {
  const sectionId = window.quickshopSectionId;
  if (!sectionId || !productUrl) {
    return Promise.resolve(false);
  }

  const url = `${productUrl}${productUrl.includes('?') ? '&' : '?'}section_id=${sectionId}`;

  return fetch(url)
    .then(response => response.text())
    .then(data => {
      const quickshopHtml = showQuickshop(data);
      const quickShopContent = document.getElementById(selectors.modalContent);
      if (!quickShopContent) {
        return false;
      }

      quickShopContent.innerHTML = quickshopHtml;
      const product = quickShopContent.querySelector(selectors.modalProduct);
      if (!product) {
        return false;
      }

      new Product(product, {
        isQuickShop: true,
        klaviyoTrackViewedProduct: true,
        quickShopUrl: productUrl,
      });

      reinitSwymActionButtons(product);

      openModal('quickshop');
      return true;
    })
    .catch(() => false);
}
